<template>
  <div>
    <v-dialog v-model="dialog">
      <template #activator="{ on }">
        <v-list-item v-on="on">
          <v-list-item-title @click="getData">
            Access Exceptions
          </v-list-item-title>
        </v-list-item>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Access Exceptions</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="access"
                  label="Access Exceptions"
                  required
                />
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="save"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import api from '@/services';

export default {
    data: () => ({
        dialog: false,
        access: null,
    }),
    methods: {
        async save() {
            await api.setAccess(JSON.parse(this.access));
            this.dialog = false;
        },
        async getData() {
            const accessConfig = await api.getAccess();
            this.access = JSON.stringify(accessConfig.data);
        },
    },
};
</script>
